import "../styles/about.css"
import KylePortraitOutside from "../../src/assets/images/kyle_portrait_outside.jpg"
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import KyleCVFile from "../../src/assets/files/KyleVeloso_CV.pdf"
import { Timeline } from "../components/Timeline"
import { useEffect } from "react"
import { NightSky } from "../components/art/NightSky"
import { myHistory } from "../const/timelineData"
import applyLandscapeAnimation from "../helper/landscapeAnimationHelper"

function PageAbout() {

    useEffect(() => {

        window.scrollTo(0, 0)
        let t1 = gsap.timeline({onStart: setScrollTriggers})
        t1.set(".main-grid", {x: "200vw",}, 0)
        t1.set(".history-timeline__timeline-item", {x: "200vw",}, 0)
        t1.fromTo(".background-about", {backgroundImage: `linear-gradient(to bottom, black 0%, black 80%, black 100%)`},
        {
            backgroundImage: `linear-gradient(to bottom, rgba(2,0,36,1) 10%, rgba(12,68,170,1) 70%, rgba(140,112,23,1) 90%)`,
            duration: 1,
            ease: "power3.in",
        }, 0)
        t1.fromTo(".main-grid",
            {x: '200vw', backgroundColor: `transparent`},
            {x: 0, duration: 1, repeat: 0, ease: "power3.out"}, 0.25
        )
    }, [])

    function setScrollTriggers() {
        gsap.registerPlugin(ScrollTrigger)
        let tSlideIn = gsap.timeline({
            scrollTrigger: {
                trigger: ".main-about__history-timeline",
                endTrigger: ".main-about__history-timeline",
                start: "top 80%",
                end: "top 20%",
                scrub: true
            },  
        })
        tSlideIn.fromTo(".history-timeline__timeline-item", {x: "50vw", opacity: 0},{x: "0", opacity: 1, stagger: 0.25,})
        
        let tSlideOut = gsap.timeline({
            scrollTrigger: {
                trigger: ".main-about__history-timeline",
                start: "bottom 60%",
                end: "bottom 20%",
                scrub: true
            },  
        })
        tSlideOut.fromTo(".history-timeline__timeline-item", {x: "0", opacity: 1},{x: "-50vw", opacity: 0, stagger: 0.25, reversed: true
        })
        let tScrollBackground = gsap.timeline()
        let mountainTrigger = applyLandscapeAnimation({
            trigger: ".main-about",
            endTrigger: ".main-about__section-whoami",
            start: "top top",
            end: "center top",
            y: "50vh"
        })

        let skyAnimTrigger = ScrollTrigger.create({
            trigger: ".main-about__section-whoami",
            endTrigger: ".main-about",
            start: "top top",
            end: "bottom bottom",
            scrub: true,
            animation: gsap.fromTo(".sky-background", {
                backgroundImage: `linear-gradient(to bottom, rgba(2,0,36,1) 10%, rgba(12,68,170,1) 70%, rgba(140,112,23,1) 90%)`,
            },
            {
                backgroundImage: `linear-gradient(to bottom, rgba(0,0,0,1) 20%, rgba(9,30,68,1) 92%, rgba(4,23,27,1) 100%)`,
            })
        })
        let tCloudsAnimTimeline = gsap.timeline({
            scrollTrigger: {
                trigger: ".main-about__history-timeline",
                endTrigger: ".main-about__history-timeline",
                start: "top 90%",
                end: "bottom center",
                scrub: true
            }
        })

        tCloudsAnimTimeline.fromTo(".bg-clouds-container", {y: "-80vh"}, {y: "120vh"}, 0)
        tCloudsAnimTimeline.fromTo(".bg-clouds-container .bg-cloud-1", {x: "-100vw"}, {x: "400vw"}, 0)
        tCloudsAnimTimeline.fromTo(".bg-clouds-container .bg-cloud-2", {x: "40vw"}, {x: "25vw"}, 0)
        tCloudsAnimTimeline.fromTo(".bg-clouds-container .bg-cloud-3", {x: "-40vw"}, {x: "60vw"}, 0)
        // tCloudsAnimTimeline.fromTo(".bg-clouds-container .bg-cloud-2", {x: "-100vw"}, {x: "400vw"})
        // tCloudsAnimTimeline.fromTo(".bg-clouds-container .bg-cloud-2", {x: "-100vw"}, {x: "400vw"})
        
        tScrollBackground.add(mountainTrigger.animation)
        tScrollBackground.add(skyAnimTrigger.animation)
    }

    return (
        <>
            <div className="sky-background background-about"></div>
            <main className="main-about">
                <NightSky></NightSky>
                <div className="bg-clouds-container">
                    <div className="bg-cloud bg-cloud-1"></div>
                    <div className="bg-cloud bg-cloud-2"></div>
                    <div className="bg-cloud bg-cloud-3"></div>
                </div>
                <div className="main-grid">
                    <section className="main-about__section-whoami">
                        <h2>About Me</h2>
                        <div>
                            <p>
                                My name is Kyle Veloso, but you can call me <span className="emp-text">Kyle V</span>! I am currently a <span className="emp-text">Junior Developer</span> based
                                in Montr&eacute;al, Canada.
                            </p>

                            <p>
                                I am looking to explore my next opportunity for a full-time position in Montreal, Canada.

                            </p>
                            <p>
                                What makes me intriged into programming and software development is my interest on how things work, from the top to the bottom from just lines of text.
                                The process of developing software from planning to squashing bugs to adding new features sparks my drive to travel to unexplored territory beyond my comfort zone.
                            </p>
                            <p>
                                My journey into the vast world started way long ago before studying Computer Science. 
                                I wrote my first line of code back when I was still in elementary school.
                                I used to have an huge career aspiration in Chemistry. Although Chemistry is still in my interest, I realized that chemistry and my true passion
                                did not truly mix.
                                That is when I started studying <span className="emp-text">Computer Science</span> in 2020. During my collegial studies, I learned the ropes of being a developer and created different projects
                                <span className="emp-text"> from simple console apps to a full responsive website 💻.</span> It felt great like magic.         
                            </p>
                            <a className="link-button" href={KyleCVFile} download><i className="fa fa-download"></i> Download CV</a>
                        </div>
                    </section>
                    <section className="main-about__section-portrait">
                        <img src={KylePortraitOutside} alt="A preview of some videos on my youtube channel" ></img>
                    </section>
                    <section className="main-about__section-hobby-portion">
                        <h2>When I am not coding, </h2>
                        <p>I like <span className="emp-text">creating video content</span> 🎥 for YouTube, making videos for people to feel tingly and calm. I even fall for it. I also like <span className="emp-text">Space</span> 🪐 and watching mystery 🕵️ type of videos. I also started
                            picking up <span className="emp-text">chess</span> ♟️, though I have a 500 rating 😅.
                        </p>
                        
                    </section>
                    <section className="main-about__section-timeline">
                        <h2>How did I end up here? Walk me through my path.</h2>
                        <Timeline data={myHistory}></Timeline>
                    </section>
                </div>
                <div className="planet-landscape-container">
                    <div className="planet-i-mountain-container">
                        <div className="planet-i-mountain planet-i-mountain-1"></div>
                    </div>
                    <div className="planet-i-mountain-container">
                        <div className="planet-i-mountain planet-i-mountain-2"></div>
                    </div>
                    <div className="planet-i-mountain-container">
                        <div className="planet-i-mountain planet-i-mountain-3"></div>
                    </div>
                    <div className="planet-i-surface"></div>
                </div>
            </main>
        </>

    )
}

export default PageAbout